const SHANGHAI = 'Asia/Shanghai'

function formatFromMs(ms) {
  const fmt = new Intl.DateTimeFormat('en-CA', {
    timeZone: SHANGHAI,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  })
  const parts = Object.fromEntries(
    fmt.formatToParts(new Date(ms))
      .filter(item => item.type !== 'literal')
      .map(item => [item.type, item.value])
  )
  return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}:${parts.second}`
}

/** 后台流水/运营时间：有时区按瞬间转东八区，无时区按已是上海墙钟展示。 */
export function formatShanghaiDateTime(value) {
  if (value == null || value === '') return '-'
  if (typeof value === 'number' && Number.isFinite(value)) {
    return formatFromMs(value)
  }
  const raw = String(value).trim()
  if (!raw) return '-'
  if (/[zZ]|[+-]\d{2}:?\d{2}$/.test(raw)) {
    const date = new Date(raw)
    return Number.isNaN(date.getTime()) ? raw.replace('T', ' ').slice(0, 19) : formatFromMs(date.getTime())
  }
  return raw.replace('T', ' ').slice(0, 19)
}
